import React, { Component } from 'react';
import { apiReadOneAsset } from '../../../../utils/apis';

 
import VideoPlayer from '../../../../components/bases/videoplayer/videoplayer';
import Transcript from '../transcript/transcript';
import EditListSt from '../subtitles/list-st/edit-list-st'
import { configurations_getDefaultParams } from '../../../../utils/configurations';

import { AppExport_ExportType } from '../../../../utils/software';
import { V2_ConvertSecondToTimeCodeStringFromAsset, V2_getIntervalStringFromAsset } from '../../../../utils/timecodev2';
import "./exportsstyles.css"

class ExportShowAssert extends React.Component
{

constructor (props)
{
    super(props);
    this.state =
    {
        asset: 0,
    }

    this.transcriptRef = React.createRef();
    this.editListeStRef = React.createRef();
    this.subtitleListRef = React.createRef();
    this.playerVideoRef = React.createRef();

    this.apiCallBackReadOneAsset = this.apiCallBackReadOneAsset.bind(this);
    this.subtitlemove = this.subtitlemove.bind(this);
    this.getTimeCodeString = this.getTimeCodeString.bind(this);
    this.getIntervalString = this.getIntervalString.bind(this);

    this.stparams = configurations_getDefaultParams();
  
        this.displayParameters = {
          fontName: 'Arial', // « nom de la police à utiliser »
          borderWidth: '5px', // épaisseur de la bordure autour du caractère
          borderColor: 'black', // « black »
          marginLeft: '5%',
          marginRight: '5%',
          marginTop: '5%',
          marginBottom: '5%',
          displayNumberOfLines: 23, // 10….50
        };
     


}



componentDidMount()
{
    // on commence par lire l'asset
    console.log("Debut de lecture de fichier exporte ", this.props.assetid)
    if (this.props.assetid > 0)
        apiReadOneAsset ({asid: this.props.assetid}, this.apiCallBackReadOneAsset)                                                                                                              

}                                                                                    
componentDidUpdate()
{
    console.log("Debut de lecture de fichier exporte update ", this.props.assetid)
    if (this.props.assetid > 0)
        apiReadOneAsset ({asid: this.props.assetid}, this.apiCallBackReadOneAsset)                                                                                                              

}
apiCallBackReadOneAsset(datas)               
{                                        

                                                                                                                  
    console.log ("lecture fichier exporté ", datas)
    // on a lu l'asset
    if (datas.ret)
    {
        // var subtitles = JSON.parse(datas.asdatas);
        console.log("display asset", datas);
        switch (datas.astype)
        {
            case 1:
            case 2:
            case 6:

                // compatibilité avec ancienne version
                var alldatas = JSON.parse(datas.asdatas);
                var transcription = alldatas;
                if ("transcription" in alldatas)
                    transcription = alldatas.transcription;


                if ((this.transcriptRef) && (this.transcriptRef.current))
                    this.transcriptRef.current.setTranscription(transcription,this.props.asset.asid,-1,this.props.asset.astitle,this.props.asset.asfile);
                break;
            case 3: 
        
                break;
            case 4:
          case 5:
            var asdatas = JSON.parse(datas.asdatas);
            var subtitles = asdatas.subtitles;
            var params = asdatas.params;
                subtitles.forEach((subtitle, index) => {
                    subtitle.id = index;
                  });
            
                if ((this.editListeStRef) && (this.editListeStRef.current))
                {

                
                    this.editListeStRef.current.setSubtitles(
                      this.props.asset.asid,
                      params,
                      subtitles
                    );
                }
                break;
        }
    
    }
    else
        console.log("Lecture asset return false")

}

  subtitlemove(id, timeCode) {
 
    if (this.editListeStRef && this.editListeStRef.current) {

      this.editListeStRef.current.setCurrentSubtitle(
        id,
        false
      );
    }

  }

    getTimeCodeString(time) {
      return V2_ConvertSecondToTimeCodeStringFromAsset(time, this.props.asset);
    } 

    getIntervalString(timebefore, time)
    {
      return V2_getIntervalStringFromAsset(timebefore, time, this.props.asset, false);
    }


render()
{

    var title = (<></>);
    if (this.props.asset !==  null)
    {
        title = (<>
            <span className="exportshowasset_title">
            {this.props.asset.asid}-{this.props.asset.astitle}
            </span></>
            )
    }

    var corps = (<></>);


    if (this.props.asset)
    {
        if (this.props.fileformat === AppExport_ExportType.transcription)
        {
            corps = (

                <Transcript ref = {this.transcriptRef}
                        readonly={true}                   
                        noCursor={true}
                        timecodeAsset = {this.props.asset}
                        initialFontSize = {13}
                        showSpeakers={false}
                            />                
            )

        }


        if (this.props.fileformat === AppExport_ExportType.subtitle)
            {
                console.log("creation EditListST with ", this.stparams)
                corps = (
                    <EditListSt
                    ref={this.editListeStRef}
                    Zindex={0}
                    readonly={true}
                    subtitleParameters={this.stparams}
                    displayParameters = {this.displayParameters}
                    getTimeCodeString = {this.getTimeCodeString}
                    getIntervalString = {this.getIntervalString}
                    onMove={this.subtitlemove}
                    />
                )
    
            }
    
    

    }
    return (<>
        <div className='export_assettitle'>
        {title}
        </div>
        <div className='export_assetdatas'>
        {corps}
        </div>
    </>)
}


}


export default ExportShowAssert;

